import api from './axios';

// ==================== INTERFACES ====================

export interface CapacityData {
    capacidadCarros: number;
    capacidadMotos: number;
    capacidadTotal: number;
    ocupacionCarros: number;
    ocupacionMotos: number;
    ocupacionTotal: number;
    disponiblesCarros: number;
    disponiblesMotos: number;
    disponiblesTotal: number;
    porcentajeOcupacion: number;
    porcentajeCarros: number;
    porcentajeMotos: number;
}

export interface UpdateCapacityData {
    capacidadCarros?: number;
    capacidadMotos?: number;
}

// ==================== API FUNCTIONS ====================

/**
 * Obtiene la capacidad configurada y ocupación actual del parqueadero
 */
export async function getCapacity(): Promise<CapacityData> {
    const response = await api.get('/spaces/capacity');
    return response.data;
}

/**
 * Actualiza la capacidad del parqueadero
 */
export async function updateCapacity(data: UpdateCapacityData): Promise<CapacityData> {
    const response = await api.patch('/spaces/capacity', data);
    return response.data;
}
